import { render, staticRenderFns } from "./TaskListTree.vue?vue&type=template&id=86ec2568&scoped=true&"
import script from "./TaskListTree.vue?vue&type=script&lang=js&"
export * from "./TaskListTree.vue?vue&type=script&lang=js&"
import style0 from "./TaskListTree.vue?vue&type=style&index=0&id=86ec2568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ec2568",
  null
  
)

export default component.exports